/*
 * @author YangLiQiChun
 * @date 2023/4/5
 * @time 15:33
 * @desc:
 */

// import * as canvas from "./canvas";
// import * as date from "./date";
// import * as download from "./download";
// import * as file from "./file";
// import * as richTextUtils from "./richTextUtils";
// import * as routeConvert from "./routeConvert";
import * as util from "./util";
// import * as currency from "./currency";
import * as domUtil from "./domUtil";

// export * from "./canvas";
// export * from "./date";
// export * from "./download";
// export * from "./file";
// export * from "./richTextUtils";
// export * from "./routeConvert";
export * from "./util";
// export * from "./currency";
export * from "./domUtil";

export default {
  // canvas,
  // date,
  // download,
  // file,
  // richTextUtils,
  // routeConvert,
  util,
  // currency,
  domUtil,
};

export function checkIsPcByUa() {
  const userAgentInfo = navigator.userAgent;
  const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
